var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Lazy Slider"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeLazy) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_vm._v(" The value will only be updated when the drag is over ")]), _c('b-card-text', [_vm._v("value: " + _vm._s(_vm.value))]), _c('vue-slider', {
    attrs: {
      "lazy": true,
      "direction": _vm.direction
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }